import { render, staticRenderFns } from "./MenuListTableTwo.vue?vue&type=template&id=79e02c79&scoped=true"
import script from "./MenuListTableTwo.vue?vue&type=script&lang=js"
export * from "./MenuListTableTwo.vue?vue&type=script&lang=js"
import style0 from "./MenuListTableTwo.vue?vue&type=style&index=0&id=79e02c79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e02c79",
  null
  
)

export default component.exports